import { inject, Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

export const DATEPICKER_I18N = {
  vi: {
    weekdays: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
    months: [
      'Th1',
      'Th2',
      'Th3',
      'Th4',
      'Th5',
      'Th6',
      'Th7',
      'Th8',
      'Th9',
      'Th10',
      'Th11',
      'Th12',
    ],
    weekLabel: 'Tuần',
  },
  en: {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    weekLabel: 'Wk',
  },
};

@Injectable()
export class SSDatepickerI18n extends NgbDatepickerI18n {
  private translate = inject(TranslateService);

  private get i18n() {
    const lang = this.translate.getCurrentLang() === 'en' ? 'en' : 'vi';
    return DATEPICKER_I18N[lang];
  }

  getWeekdayLabel(weekday: number): string {
    return this.i18n.weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return this.i18n.months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}/${date.month}/${date.year}`;
  }
  format(date: NgbDateStruct): string {
    return date ? `${date.day}/${date.month}/${date.year}` : '';
  }
}
